import React from 'react'
import { Heading, Lead } from '../../ui/Text'
import styles from './styles.module.scss'

interface EligibilityCard {
    title: string
    description: string
    icon?: string
}

const EligibilityChecklist: React.FC = () => {
    const criteria: EligibilityCard[] = [
        {
            title: 'Served in the UK Armed Forces',
            description: 'You must have served in the Army, Navy, Royal Air Force, or Army Reserves',
        },
        {
            title: 'Service after 1987',
            description: 'Any period of your service must have been conducted after 1987',
        },
        {
            title: 'Hearing loss or tinnitus',
            description: 'You suffer from hearing loss or tinnitus (ringing or buzzing in your ears)',
        },
    ]

    return (
        <section className={styles.eligibilitySection}>
            <div className={styles.container}>
                <Heading align="center" className={styles.title}>
                    Are you eligible?
                </Heading>
                <Lead align="center" className={styles.subtitle}>
                    You could have a claim if these apply to you
                </Lead>

                <div className={styles.cardsGrid}>
                    {criteria.map((item, index) => (
                        <div key={index} className={styles.card}>
                            <span className={styles.cardNumber}>{String(index + 1).padStart(2, '0')}</span>
                            <h3 className={styles.cardTitle}>{item.title}</h3>
                            <p className={styles.cardDescription}>{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default EligibilityChecklist
